import React, { useState, useEffect } from "react";
import * as ruleService from "../ruleService";
import { deepCopy } from "../../utils";
import SelectV2 from "../../view/SelectV2";

function SelectMsbDropdown({ setMsbId, msbId }) {

    const [msbList, setMsbList] = useState([]);

    const ListCustomMsbs = async () => {
        const msbList = await ruleService.getNonbaseMsbs();
        setMsbList(msbList || []);
    };

    useEffect (() => {
        ListCustomMsbs();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])



    const onChange = (id) => {
        setMsbId(id);
    }

    const msbRenderList = deepCopy(msbList);
    const options = msbRenderList.map((msb) => ({
        value: msb.id,
        label: msb.name
    }));

    return (
        <div className="oct-shared-popup__field">
            <label className="oct-shared-popup__label" htmlFor="msb">
                Select MSB <span className="oct-shared-popup__required-mark">*</span>
            </label>
            <div className="oct-shared-popup__select-wrap">
                <SelectV2
                    inputId="msb"
                    value={Number(msbId) > 0 ? msbId : ""}
                    onChange={onChange}
                    options={options}
                    isSearchable={true}
                    placeholder="Choose an MSB"
                    noOptionsMessage={() => "No MSBs found"}
                />
            </div>
        </div>
    )

}

export default SelectMsbDropdown;
